import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { FeatureFlagsOptions } from '@/hooks/useFeatureFlags/types';

/**
 * O portão da rota `/central-manutencao`.
 *
 * A rota lia `featureFlags.ff_manutencao` direto e ignorava o `loading` do
 * mesmo hook. O mapa de flags nasce com tudo `false` e só é preenchido quando
 * o PostHog responde — então em F5 ou URL direta, no primeiro render a flag
 * está falsa por AUSÊNCIA de resposta, não por decisão, e o `<Navigate
 * replace>` disparava mesmo para quem tinha acesso.
 *
 * Efeito prático: a aba e o card abertos, que moram em `?aba=` e `?agente=`
 * (ver `urlState.ts`) para sobreviver ao F5, nunca chegavam a renderizar — a
 * pessoa caía em `/home` antes de a URL importar. Mesmo desenho de
 * `CentralAtividadesGate` e `PortaoDaJornada`: `if (loading) return null`
 * antes de qualquer leitura de flag.
 */
export const CentralManutencaoGate = ({ children }: { children: ReactElement }) => {
  const { featureFlags, loading } = useFeatureFlags();

  if (loading) return null;

  if (!featureFlags[FeatureFlagsOptions.FF_MANUTENCAO]) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default CentralManutencaoGate;
